import {DataFrame} from 'data-frames/DataFrameTypes';
import {RunQueryData} from 'insights/warehouse/AnalyticsWarehouseDAO';
import {AsyncState} from 'ui-library/hooks/useAsyncState';
import {JSONValue} from 'util/Types';

export type Row = Array<JSONValue>;

// TODO(BNCH-35967): Remove `headers` and `rows` once run query back-end is guaranteed to return data frames
export interface RunQueryOutput {
  dataFrame: DataFrame;
  rawSQLQuery: string;
  isTruncated: boolean;
}

/**
 * Type describing the deprecate version of RunQueryOutput that contained the output data in the `headers`
 * and `rows` fields.
 *
 * @deprecated New usages of this type are discouraged and should instead prefer to use `RunQueryOutput`
 */
// TODO(BNCH-24546): Remove LegacyRunQueryOutput and replace usages with RunQueryOutput.
export interface LegacyRunQueryOutput extends RunQueryOutput {
  headers: Array<string>;
  rows: Array<Row>;
}

/**
 * Utility type describing the parts of RunQueryOutput that will be replaced with a DataFrame
 *
 * @deprecated New usages of this type are discouraged and should instead prefer to use the dataFrame portion of RunQueryOutput
 * once available.
 */
// TODO(BNCH-24546): Remove RunQueryOutputLegacyData and replace usages with DataFrame once 'headers' and 'rows are gone.
export type RunQueryOutputLegacyData = Pick<LegacyRunQueryOutput, 'headers' | 'rows'>;

export type RunQueryState = AsyncState<RunQueryOutput, [RunQueryData]>;

/**
 * Type describing the deprecated version of `RunQueryState` that used what is now `LegacyRunQueryOutput`.
 *
 * @deprecated New usages of this type are discouraged and should instead prefer to use `RunQueryState`
 */
// TODO(BNCH-24546): Remove LegacyRunQueryState and replace usages with RunQueryState.
export type LegacyRunQueryState = AsyncState<LegacyRunQueryOutput>;

// Keep in sync with benchling/insights/warehouse/export_type.py
export enum ExportType {
  RAW_OUTPUT_CSV = 'RAW_OUTPUT_CSV',
  RESOLVED_OUTPUT_CSV = 'RESOLVED_OUTPUT_CSV',
}

export interface ExportQueryOutputSettings {
  exportType: ExportType;
  filename: string;
}
